module.exports = __webpack_public_path__ + "static/Product_designing_and_Prototyping-562f5ad0193f620d51a4763228f8a166.png";